export default "__VITE_ASSET__CTkQL4qv__"